import React from "react";
import { FOUNDER_QUOTE } from "./founderQuoteContent.js";

const FounderQuoteSection = () => (
  <section className="cursor-section roofing-founder-quote" data-testid="roofing-founder-quote">
    <div className="cursor-container">
      <figure className="roofing-founder-quote-figure">
        <blockquote className="roofing-founder-quote-text">
          <p>{FOUNDER_QUOTE.text}</p>
        </blockquote>
        <figcaption className="roofing-founder-quote-by">
          <span className="roofing-founder-quote-name">{FOUNDER_QUOTE.name}</span>
          <span className="roofing-founder-quote-role">{FOUNDER_QUOTE.role}</span>
        </figcaption>
      </figure>
    </div>
  </section>
);

export default FounderQuoteSection;
